export const reviewContent = {
    es: {
        title: 'Lo que opinan nuestros clientes',
        ratingLine: '4,5 sobre 5 — más de 1204 opiniones',
        reviews: [
            { text: 'Muy buen IPTV y una atención al cliente excelente.', name: 'Javier García', location: 'Madrid' },
            { text: 'Servicio excepcional, calidad perfecta.', name: 'María López', location: 'Barcelona' },
            { text: 'El mejor IPTV que he probado.', name: 'Alejandro Martínez', location: 'Valencia' },
            { text: 'Excelente atención al cliente y calidad premium.', name: 'Carmen Sánchez', location: 'Sevilla' },
            { text: 'IPTV de calidad, lo recomiendo totalmente.', name: 'Pablo Fernández', location: 'Bilbao' },
            { text: 'Servicio impecable, muy satisfecho.', name: 'Lucía Romero', location: 'Zaragoza' },
            { text: 'La mejor opción de IPTV premium.', name: 'Diego Torres', location: 'Málaga' },
        ],
    },
};
